// B10 S17 · B10's part of B1's Action Center (CR-092; plan D11): its tier groups, chips, filters and saved views over
// B1's `action_center.list`, on B1's `#action-center` route (registered server-side in app/routes.py, badged by B1's
// shell). B1's own Action Center screen is in the same view registry (views/b1/register.ts) at the same specificity
// and registers first, and a tie goes to the earlier registration, so B1's screen is the one drawn (Debt 8); this line
// stays registered (through views/b10/shell.ts) for the day B1's screen hosts these parts. Gated on `action_center.list`:
// a reader whose manifest does not carry it gets the not-found screen (N02). This file binds the page to the router and
// to S19's *Saved views* select, so the page module itself loads without either.
import { createElement } from "react";
import { go, type Route } from "@/router";
import { SavedViewsSelect } from "@/views/b10/lib/savedViews";
import { queryOf, registerView } from "@/views/b10/shell";
import { ActionCenterPage } from "./ActionCenterPage";
import { parseActionQuery } from "./Filters";

function ActionCenterRoute({ route }: { route: Route }) {
  return createElement(ActionCenterPage, { query: parseActionQuery(queryOf(route)), navigate: go, SavedViews: SavedViewsSelect });
}

registerView(/^action-center$/, ActionCenterRoute, { lane: "B10", gates: ["action_center.list"] });
